export default {
  'pointHistory.title': 'Point History',
  'pointHistory.event.deduct': 'Point Deduction',
  'pointHistory.event.collect': 'Point Collection',
  'pointHistory.event.transfer': 'Point Transfer',
  'pointHistory.event.0': 'Not eligible for points',
  'pointHistory.event.1': 'Points awarded for reaching threshold',
  'pointHistory.event.4': 'Flexible point awarding',
  'pointHistory.event.10': 'Flexible point deduction',
  'pointHistory.event.20': 'Auto coupon conversion point deduction',
  'pointHistory.event.21': 'Manual coupon selection point deduction',
  'pointHistory.event.22': 'Points expired',
  'pointHistory.event.90': 'Point accumulation cancelled',
  'pointHistory.event.91': 'Transaction cancelled - points deducted',
  'pointHistory.event.92': 'Transaction cancelled - auto coupon conversion points refunded',
  'pointHistory.event.93': 'Point awarding cancelled',
  'pointHistory.event.94': 'Point deduction cancelled',
  'pointHistory.message.cancel_success': 'Points collection cancelled successfully',
  'pointHistory.message.cancel_fail': 'Failed to cancel points collection',
  'pointHistory.current_points': 'Current points',
  'pointHistory.expiration_date': 'Expiration date',
  'pointHistory.button.cancel': 'Cancel',
  'pointHistory.empty': 'No data',
  'pointHistory.point_detail': 'Point details',
  'pointHistory.processing_time': 'Processing time',
  'pointHistory.remark': 'Remark',
  'pointHistory.consumption_amount': 'Consumption amount',
  'pointHistory.bottomDateRange.dateFrom': 'Start Date',
  'pointHistory.bottomDateRange.dateTo': 'End Date',
  'pointHistory.bottomDateRange.error.dateFrom': 'Please select a start date',
  'pointHistory.bottomDateRange.error.dateTo': 'Please select an end date',
  'pointHistory.bottomDateRange.error.dateRange': 'Start date cannot be later than end date',
  'pointHistory.bottomDateRange.search': 'Search',
  'pointHistory.bottomDateRange.cancel': 'Cancel',
} as Record<string, string>;
